export default "__VITE_ASSET__U05Ixk0m__"